module.exports = __webpack_public_path__ + "img/megaphone.c2bba1dd.svg";